/**
 * Back-to-top button. Appears after one third of the page is scrolled (latched
 * so it does not flicker during infinite scroll). On desktop >=990px, Horizon
 * scrolls `.page-wrapper` (html is overflow:hidden), not the window, so read
 * and listen on that container; otherwise window.scrollY stays at 0 and the
 * button never shows.
 */
(function () {
  if (window.bqBackTopInit) return;
  window.bqBackTopInit = true;

  var btn = document.querySelector('.bq-backtop');
  if (!btn) return;
  btn.hidden = false; // revealed only when the JS runs

  var reduced = false;
  try { reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}
  var squeeze = window.matchMedia('(min-width: 990px)');

  function container() {
    return (squeeze.matches && document.querySelector('.page-wrapper')) ||
      document.scrollingElement || document.documentElement;
  }
  function eventTarget() {
    return (squeeze.matches && document.querySelector('.page-wrapper')) || document;
  }

  var ticking = false;
  var shown = false;
  function update() {
    ticking = false;
    var c = container();
    var max = c.scrollHeight - c.clientHeight;
    var y = c.scrollTop;
    if (!shown && max > 0 && y > max / 3) shown = true;
    else if (shown && y < c.clientHeight * 0.5) shown = false;
    btn.classList.toggle('is-visible', shown);
  }
  function onScroll() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(update);
  }

  var bound = null;
  function bind() {
    if (bound) bound.removeEventListener('scroll', onScroll);
    bound = eventTarget();
    bound.addEventListener('scroll', onScroll, { passive: true });
    update();
  }
  bind();
  // Rebind when crossing the 990px threshold (the scroll container changes).
  squeeze.addEventListener('change', bind);
  window.addEventListener('resize', onScroll, { passive: true });

  btn.addEventListener('click', function () {
    container().scrollTo({ top: 0, behavior: reduced ? 'auto' : 'smooth' });
  });
})();
